import PageOverview from './PageOverview';
import { connect } from 'react-redux';
import {
  deleteLocation,
  listLocations,
  editLocation,
  clearAddress,
  getAddress,
} from '../../actions/location';
import { submitMeterRead } from '../../actions/meterRead';
import { AppState } from '../../interfaces';

const mapStateToProps = (state: AppState) => ({
  listLocation: state.listLocationReducer,
  location: state.locationReducer,
  meterRead: state.meterReadReducer,
});

const mapDispatchToProps = (dispatch) => ({
  listLocations: () => dispatch(listLocations()),
  deleteLocation: (id) => dispatch(deleteLocation(id)),
  editLocation: (id, data) => dispatch(editLocation(id, data)),
  getAddress: (postcode) => dispatch(getAddress(postcode)),
  clearAddress: () => dispatch(clearAddress()),
  submitMeterRead: (propertyId, meterRead) =>
    dispatch(submitMeterRead(propertyId, meterRead)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageOverview);
